<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="card_container" style="border-radius: 17px">
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.targets.title") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/target (1).svg" width="35px" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>{{ targetsCount }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_order"
          style="border-radius: 22px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div
              class="row align-items-center section__row justify-content-center"
            >
              <div class="col-md-6 text-center">
                <div style="width: 90%">
                  <span class="" style="color: white; font-size: 30px">
                    {{ $t("text.targets.branchTargets") }}
                  </span>
                </div>
                <div class="text-center mt-5" style="">
                  <button
                    class="save__btn"
                    @click="openCreateTargetModal"
                    style="font-size: 18px"
                  >
                    {{ $t("text.targets.createTarget") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12 mt-3">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column
                  width="40"
                  field="index"
                  headerText="#"
                  style="font-szie: 30px"
                ></e-column>
                <e-column
                  field="product"
                  width="150"
                  :headerText="$t('text.targets.product')"
                ></e-column>
                <e-column
                  field="quantity"
                  width="150"
                  format="N0"
                  :headerText="$t('text.targets.quantity')"
                ></e-column>
                <e-column
                  :template="actionButtonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                  width="120"
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </section>
      <section
        class="products_summary__wrapper pb-3"
        v-if="targetsCount < 1 && !showLoader"
      >
        <div
          class="empty_tank_wrapper"
          style="
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column wrap;
          "
        >
          <div class="text-center" style="margin-top: 100px">
            <h3 style="color: rgb(161, 146, 146); font-size: 25px">
              {{ $t("text.targets.emptyTarget") }}
            </h3>
          </div>

          <div class="text-center mt-5">
            <img src="@/assets/img/target (1) (1).svg" width="100" />
          </div>

          <div class="text-cente pb-5" style="margin-top: 50px">
            <h3 style="color: rgb(161, 146, 146); font-size: 25px">
              {{ $t("text.targets.emptyTarget") }}
            </h3>
          </div>
        </div>
      </section>
      <TableLoader :showLoader="showLoader"></TableLoader>

      <CreateTargetModal
        :branchId="branchId"
        :targets="targets"
      ></CreateTargetModal>
      <EditTargetModal :target="target" :branchId="branchId"></EditTargetModal>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
import CreateTargetModal from "@/components/modals/Targets/createTargetModal.vue";
import EditTargetModal from "@/components/modals/Targets/editTargetsModal.vue";

let $ = JQuery;

export default {
  name: "Pump_Details",
  components: {
    MasterLayout,
    CreateTargetModal,
    EditTargetModal,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      backgroundUrl,
      targetsCount: 0,
      targets: [],
      formIsValid: false,
      isButtonDisabled: false,
      target: {},
      showLoader: false,
      branch: {},
      branchId: null,
      bankAccounts: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      actionButtonsTemplate: function () {
        return {
          template: Vue.component("actionButtonsTemplate", {
            template:
              '<div class="btn-group btn-group-sm" role="group">' +
              '<button type="button" class="btn btn-primary" :title="data.editTarget" v-on:click="edit_target(data.product)" >' +
              '<i class="fa fa-edit" aria-hidden="true"></i>' +
              "</button>" +
              '<button type="button" class="btn btn-danger" :title="data.deleteTarget" v-on:click="removeTarget(data.product, data.quantity)" >' +
              '<i class="fa fa-trash-o" aria-hidden="true"></i>' +
              "</button>" +
              "</div>",
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              edit_target: function (product) {
                this.$eventHub.$emit("editTargetModel", product);
              },

              removeTarget: function (product, qty) {
                this.$eventHub.$emit("_removeTarget", product, qty);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    document.title = "Targets:: Epump Retail Outlet";
    this.branchId = this.$route.query.id;
    this.branch = localStorage.getItem("branchDetails")
      ? JSON.parse(localStorage.getItem("branchDetails"))
      : null;

    this.$eventHub.$on("_removeTarget", (product, qty) => {
      this.deleteTarget(product, qty);
    });
    this.$eventHub.$on("refreshTargetsTable", () => {
      this.getTargets();
    });
    this.$eventHub.$on("editTargetModel", (product) => {
      this.editTarget(product);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("editTargetModel");
    this.$eventHub.$off("_removeTarget");
    this.$eventHub.$off("refreshTargetsTable");
  },

  mounted() {
    if (this.branch !== null) {
      this.branchId = this.branch.id;
    }
    this.getTargets();

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    openEditTargetModal() {
      this.$modal.show("editTargetModal");
    },
    editTarget(product) {
      let targetDetail = this.targets.filter(
        (target) => target.product === product
      )[0];
      this.target = targetDetail;
      this.openEditTargetModal();
    },
    openCreateTargetModal() {
      this.$modal.show("createTarget");
    },

    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    deleteTarget(product, qty) {
      const remove = confirm(this.$t("text.targets.confirmDelete"));
      if (!remove) {
        return;
      }
      let data = {
        product: product,
        quantity: qty,
        branchId: this.$route.query.id,
      };
      fetch(`${configObject.apiBaseUrl}/Target/DeleteBranchTarget`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: configObject.authConfig().headers.Authorization,
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          this.getTargets();
          this.$toast.open({
            message:
              res.status === 200
                ? this.$t("text.targets.successfullyDeleted")
                : this.$t("text.targets.targetNotFound"),
            type: res.status === 200 ? "success" : "error",
            duration: 4000,
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.targets.unsuccessfulDelete"),
            type: "error",
            duration: 4000,
          });
        });
    },
    getTargets() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Target/Branch/${this.$route.query.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.targets = response.data;
          this.targetsCount = response.data.length;
          let index = 0;
          response.data.forEach((element) => {
            element.index = ++index;
            element.editTarget = this.$t("text.targets.editTarget");
            element.deleteTarget = this.$t("text.targets.deleteTarget");
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      return request; //.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style>
@media screen and (max-width: 602px) {
  .createTargetModal .v--modal-box.v--modal {
    width: 90% !important;
    margin: 0 auto;
    left: 0 !important;
  }
  .editTargetModal .v--modal-box.v--modal {
    width: 90% !important;
    left: 0 !important;
    margin: 0 auto !important;
  }
}
</style>
